export const TRACKER_TYPE = 'trackStructEvent';
export const CATEGORY = 'search_header';
export const ACTION_CLICK = 'click';
export const CONTEXT = ['abTests'];

export const trackSearchBarClick = (positionY) => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_CLICK,
    label: 'search_bar',
    property: '',
    value: positionY?.toString() || '0',
  },
  context: CONTEXT,
});

// the verticalId here is the vertical that was clicked on in navigation,
// not the vertical that the click originated from.
export const trackVerticalClick = (verticalId, positionY) => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_CLICK,
    label: 'nav_bar',
    property: verticalId,
    value: positionY?.toString() || '0',
  },
  context: CONTEXT,
});
